import React, { ReactElement } from 'react'
import { IconButton, styled } from '@mui/material'

import MenuIcon from '@static/images/icons/menu.svg'
import CloseIcon from '@static/images/icons/close.svg'
import { useIntl } from 'react-intl'

const StyledIconButton = styled(IconButton)({
  display: 'inline-flex',
  alignItems: 'center',
})

export type MenuToggleProps = {
  onClick?: (event: React.SyntheticEvent) => void
  isToggled?: boolean
  sx?: MCDC.Props.IDefault['sx']
}

/**
 * MUI MenuToggle Wrapper
 */
export default function MenuToggle({
  onClick,
  isToggled,
  sx = {},
}: MenuToggleProps): ReactElement {
  const intl = useIntl()

  const label = intl.formatMessage({
    id: isToggled ? 'label.menuClose' : 'label.menuOpen',
  })

  return (
    <StyledIconButton
      edge="start"
      color="inherit"
      title={label}
      aria-label={label}
      onClick={onClick}
      sx={sx}
    >
      {!isToggled && <MenuIcon aria-hidden={true} />}
      {isToggled && <CloseIcon aria-hidden={true} />}
    </StyledIconButton>
  )
}
